var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{on:{"logout":_vm.logout}}),(
      this.$mystore.isAuthenticated() &&
      this.$mystore.state.event !== null &&
      this.$mystore.state.meetingSession !== null
    )?_c('v-btn',{attrs:{"elevation":"2","fab":"","right":"","fixed":"","bottom":""},on:{"click":_vm.muteUnmute}},[(_vm.microphoneMuted)?_c('v-icon',[_vm._v("mdi-microphone-off")]):_c('v-icon',[_vm._v("mdi-microphone")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }